<!-- 
  When adding new controls that are not related to companion mode,
  note that in the PreferenceLayoutComponent.getPanels() method,
  the entire Calling panel is removed when AppFeature.CompanionMode is disabled AND
  it is not a desktop app (Always On Top feature)
-->
@let brandingData = (brandingService.brandingData$ | async) || defaultBrandingSettings;
<div class="calling-container">
  <div>
    @if (appConfigService.features[AppFeature.CompanionMode]) {
      <div class="subheader">{{ 'CALLING_PREFERENCES.COMPANION_SUBHEADER' | translate }}</div>
      <form [formGroup]="companionForm">
        <div class="companion-item">
          <div>
            <mat-slide-toggle
              formControlName="rememberState"
              [style.--branding-color]="
                brandingData[BrandingField.FieldColorFontIconsListAreaItems]
              "></mat-slide-toggle>
          </div>
          <div>
            <div class="label">{{ 'CALLING_PREFERENCES.COMPANION_REMEMBER_STATE_LABEL' | translate }}</div>
            <div class="hint">
              {{ 'CALLING_PREFERENCES.COMPANION_REMEMBER_STATE_HINT' | translate }}
            </div>
          </div>
        </div>
        <div class="companion-item">
          <mat-form-field
            class="full-width"
            appearance="outline"
            floatLabel="always">
            <mat-label>{{ 'CALLING_PREFERENCES.COMPANION_RINGING_MODE_LABEL' | translate }}</mat-label>
            <mat-select formControlName="ringingMode">
              <mat-option [value]="CompanionRingingMode.CompanionDeviceOnly">
                {{ 'CALLING_PREFERENCES.COMPANION_RING_DEVICE_ONLY' | translate }}
              </mat-option>
              <mat-option [value]="CompanionRingingMode.CUCAndCompanionDevice">
                {{ 'CALLING_PREFERENCES.COMPANION_RING_CUC_AND_DEVICE' | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </form>
    }
    <div class="subheader">{{ 'CALLING_PREFERENCES.TEL_LINK_SUBHEADER' | translate }}</div>
    <mat-checkbox
      color="primary"
      matTooltip="{{ 'CALLING_PREFERENCES.TEL_LINK_AUTO_DIAL_HINT' | translate }}"
      matTooltipShowDelay="750"
      [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"
      [formControl]="autoDialTelLinksControl">
      {{ 'CALLING_PREFERENCES.TEL_LINK_AUTO_DIAL' | translate }}
    </mat-checkbox>
    @if (electronService.isRunningInElectron) {
      <div class="subheader">{{ 'CALLING_PREFERENCES.ACTIVE_CALL' | translate }}</div>
      <div>
        <mat-checkbox
          color="primary"
          matTooltip="{{ 'CALLING_PREFERENCES.ACTIVE_CALL_ALWAYS_ON_TOP_TOOLTIP' | translate }}"
          matTooltipShowDelay="750"
          [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"
          [formControl]="alwaysOnTopControl">
          {{ 'CALLING_PREFERENCES.ACTIVE_CALL_ALWAYS_ON_TOP' | translate }}
        </mat-checkbox>
      </div>
      <div>
        <mat-checkbox
          color="primary"
          matTooltip="{{ 'CALLING_PREFERENCES.SURFACE_WHEN_CALL_RINGS_IN_TOOLTIP' | translate }}"
          matTooltipShowDelay="750"
          [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"
          [formControl]="surfaceWhenCallRingsInControl">
          {{ 'CALLING_PREFERENCES.SURFACE_WHEN_CALL_RINGS_IN' | translate }}
        </mat-checkbox>
      </div>
    }
  </div>
</div>
